export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/hero2.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            With a Bachelor's and a Master's degree in Computer Science, I've
            spent the past decade immersed in technology and digital studies in
            working and collaborating in several organizations. With a wealth of
            experience and commitment, I'm eager to empower individuals to
            thrive in an ever-evolving technological journey. my passion for
            technology as a dedicated computer teacher is to develop alongside
            technology as it paves the way for definite improvement.
          </p>
        </div>
      </div>
    </section>
  );
}
